import { ReduxStore } from "../../reducers/root_reducer";

const getProps = <Props>(state: ReduxStore, props: Props) => props;

export default getProps;
